/**
 * HUB-G — Bandeau accès pages legacy (liens croisés).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, ArrowRight } from 'lucide-react';

const LINKS = [
  { to: '/activite?tab=ventes', label: 'Centre Activité · Ventes', testId: 'activite-overview-link-historique' },
  { to: '/caisse-historique', label: 'Caisse', testId: 'activite-overview-link-caisse' },
  { to: '/stock', label: 'Stock', testId: 'activite-overview-link-stock' },
  { to: '/reparations', label: 'Réparations', testId: 'activite-overview-link-reparations' },
];

export default function ActiviteOverviewAccessBanner() {
  return (
    <div
      className="rounded-xl border p-4 space-y-3"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid="activite-overview-access-banner"
    >
      <div className="flex items-start gap-3">
        <div
          className="shrink-0 w-10 h-10 rounded-xl flex items-center justify-center border"
          style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-elevated)' }}
        >
          <Activity className="w-5 h-5 text-[var(--rm-gray-200)]" />
        </div>
        <div>
          <p className="text-sm font-semibold text-[var(--rm-white)]">Pages complètes conservées</p>
          <p className="text-xs text-[var(--rm-gray-500)] mt-0.5">
            La timeline complète les outils existants — aucun remplacement des pages historiques.
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="btn-secondary px-4 py-2.5 min-h-[44px] text-sm inline-flex items-center gap-2"
            data-testid={link.testId}
          >
            {link.label}
            <ArrowRight className="w-4 h-4" />
          </Link>
        ))}
      </div>
    </div>
  );
}
